import { render, staticRenderFns } from "./VueSubmit.vue?vue&type=template&id=73de0a65&lang=pug"
import script from "./VueSubmit.vue?vue&type=script&lang=js"
export * from "./VueSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_babel-core@7.0.0-bridge.0_@babel+core@7.26._be63e07561d669ca645e719e913d25ce/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports